import type { PositionWrapperProps } from "./position-wrapper.type";

import classNames from "classnames";

import PositionMarker from "../position-marker";

import "./position-wrapper.style.less";

const PositionWrapper = ({
  marker,
  className,
  children,
}: PositionWrapperProps) => {
  return (
    <div className={classNames("position-wrapper", className)}>
      {children}
      {marker && <PositionMarker position={marker} />}
    </div>
  );
};

export default PositionWrapper;
